import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const AdvDiv = styled.div`
    order: ${(props) =>
        props.advancedEnergyCheck && !props.isEquity ? 4 : null};
    padding-bottom: ${(props) =>
        props.isEquity && !props.isMobile
            ? '48px'
            : props.marginBtm
            ? props.marginBtm
            : '20px'};
    padding-left: ${(props) => props.paddingLeft || ''};
    margin-top: ${(props) => (props.isMobile ? '10px' : '50px')} @media screen
        and (min-width: 768px) and (max-width: 1024px) and
        (orientation: portrait) {
        padding-bottom: ${(props) => props.isEquity && '10px'};
    }
    @media screen and (min-width: 1024px) {
        margin-top: '10px';
    }
    @media only screen and (min-width: 767px) and (max-width: 1025px) {
        padding-bottom: ${(props) => '0px'};
    }
    @media only screen and (min-width: 820px) and (max-width: 1180px) {
        padding-bottom: ${(props) => '0px'};
    }
`;

export const CheckBoxDiv = styled.div`
    display: flex;
    margin-left: ${(props) => (props.isEquity ? '0px' : '-21px')};
    width: ${(props) =>
        props.isEquity ? null : props.width ? props.width : '218%'};
    margin: ${(props) => (props.isEquity ? '0 auto' : null)};
    gap: ${(props) => (props.isEquity && !props.isMobile ? '30px' : null)};

    @media screen and (min-width: 1700px) and (max-width: 1830px) {
        gap: ${(props) => (props.isEquity ? '85px' : null)};
    }
    @media screen and (min-width: 1500px) and (max-width: 1600px) {
        gap: ${(props) => (props.isEquity ? '45px' : null)};
    }
    @media screen and (min-width: 1024px) and (max-width: 1600px) {
        gap: ${(props) => (props.isEquity ? '30px' : null)};
        margin-left: ${(props) => (props.isEquity ? '60%' : null)};
    }

    @media screen and (max-width: 768px) {
        margin-left: ${(props) => {
            props.isEquity && '-22px';
        }};
        width: ${(props) => (props.isEquity ? '100%' : '320px')};
        margin-top: ${(props) => props.isEquity && '5px'};
        margin-left: ${(props) => !props.isEquity && '-23px'};
        margin-bottom: ${(props) => {
            !props.isEquity && '20px';
        }};
    }
    @media screen and (min-width: 768px) and (max-width: 768px) and (orientation: potrait) {
        margin-left: ${(props) => props.isEquity && '190px'};
        width: ${(props) => props.isEquity && '142px'};
    }
    @media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
        margin-left: ${(props) => props.isEquity && '190px'};
        width: ${(props) => (props.isEquity ? '142px' : '175%')};
    }
    @media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin-left: ${(props) => props.isEquity && '8%'};
        width: ${(props) => (props.isEquity ? '50%' : '450px')};
    }
`;

export const OptionalLoadMoreView = styled.div`
    background-color: #f5f5f5;
    height: ${({ height }) => (height ? height : '200px')};
    display: flex;
    justify-content: center;
    align-items: center;
    // some space is left after grey message area
    margin: ${({ margin }) => (margin ? margin : '10px 0 0 0')};
    flex-direction: column;
    width: 100%;
    & p {
        color: #4f4f4f;
        font-size: 18px;
        font-family: AvenirNextWorld Regular;
        text-align: center;
        margin: 0 0 10px;
    }
    & button {
        padding: 10px;
        color: #1010eb;
        border: 1px solid #1010eb;
        border-radius: 20px;
        text-align: center;
        padding: 5px 13px;
        font-family: AvenirNextWorld Demi;
        font-size: 15px;
        background: #f5f5f5;
    }
`;
